import {
  Component, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChildren, QueryList, HostListener
} from '@angular/core';
import {StoreModel} from "../../models/StoreModel";
import * as _ from 'lodash';

@Component({
  selector: 'td[simpleGridDataDropdown]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    i {
      cursor: pointer;
    }

    .select button {
      width: 100%;
      text-align: left;
    }

    .select .caret {
      position: absolute;
      right: 10px;
      margin-top: 10px;
    }

    .select:last-child > .btn {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    .selected {
      padding-right: 10px;
    }

    .option {
      width: 100%;
    }
  `],
  template: `
    <div style="text-align: center">
      <!--<select class="form-control longInput" [ngFormControl]="notesForm.controls['privileges']">-->
      <select (change)="onChanges($event)" class="form-control custom longInput">
        @for (dropItem of m_dropdown; track dropItem) {
          <option [selected]="getSelected(dropItem)">{{getKey(dropItem, m_field)}}</option>
        }
      </select>
    </div>
    <!--<div *ngFor="let item of m_checkboxes">-->
    <!--<label class="pull-left">{{item.name}}</label>-->
    <!--<Input #checkInputs type="checkbox" [checked]="item.checked" value="{{item.value}}" class="pull-left" style="margin-right: 2px">-->
    <!--</div>-->
    `
})
export class SimpleGridDataDropdownComponent {
  m_dropdown: Array<any>;
  m_storeModel;
  m_field = '';
  value = '';
  m_testSelection;

  @ViewChildren('checkInputs')
  inputs: QueryList<any>;

  @Input()
  set dropdown(i_dropdown: Array<any>) {
    this.m_dropdown = i_dropdown;
  }

  @Input()
  set item(i_storeModel: StoreModel) {
    this.m_storeModel = i_storeModel;
  }

  @Input()
  set field(i_field) {
    this.m_field = i_field;
  }

  @Input()
  set testSelection(i_testSelection: (dropItem: any, storeModel) => 'checked' | '') {
    this.m_testSelection = i_testSelection;
  }

  @Output()
  changed: EventEmitter<any> = new EventEmitter();

  onChanges(event) {
    this.changed.emit({item: this.m_storeModel, value: event.target.value});
  }

  getKey(o, v) {
    return _.get(o, v);
  }

  getSelected(i_dropItem): string {
    if (this.m_testSelection) {
      return this.m_testSelection(i_dropItem, this.m_storeModel);
    }
    return '';
  }
}

